import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import base_url from '../config/Config';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import Cookies from 'js-cookie';
import PageLoader from '../components/PageLoader';

const ViewEmployee = () => {
    const [adminDetails, setAdminDetails] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [updatedAdmin, setUpdatedAdmin] = useState({});
    const location = useLocation();
    const navigate = useNavigate();
    const token = Cookies.get('authToken');
    const id = new URLSearchParams(location.search).get("id");

    useEffect(() => {
        if (!id) return;
        axios.get(`${base_url}/api/admin/view?id=${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(res => setAdminDetails(res.data))
        .catch(err => console.error("Fetch Error:", err));
    }, [id, token]);

    useEffect(() => {
        if (adminDetails) {
            setUpdatedAdmin({
                id: adminDetails.id || '',
                adminId: adminDetails.adminId || '',
                adminPassword: adminDetails.adminPassword || '',
                employeeId: adminDetails.employeeId || '',
                employeeName: adminDetails.employeeName || '',
                branchName: adminDetails.branchName || '',
                isActive: adminDetails.isActive || false
            });
        }
    }, [adminDetails]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setUpdatedAdmin(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleUpdate = async () => {
        try {
            await axios.put(`${base_url}/api/admin/update?id=${id}`, updatedAdmin, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });
            alert("Admin Updated Successfully");
            navigate("/employee/AllEmployee");
        } catch (err) {
            console.error("Update Error:", err);
            alert("Failed to update admin");
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>Admin View / Update</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='row'>

                                        <div className='col-md-4 col-lg-4'>
                                            <div className='personaldetails text-justify mt-3'>
                                                <label htmlFor="adminId">Employee User ID</label><br />
                                                <input type="text" name="adminId" id="adminId" value={updatedAdmin.adminId || ''} onChange={handleChange} placeholder='Admin ID' />
                                            </div>
                                        </div>

                                        <div className='col-md-4 col-lg-4'>
                                            <div className='personaldetails text-justify mt-3'>
                                                <label htmlFor="adminPassword">Password</label><br />
                                                <input type="password" name="adminPassword" id="adminPassword" value={updatedAdmin.adminPassword || ''} onChange={handleChange} placeholder='Password' />
                                            </div>
                                        </div>

                                        <div className='col-md-4 col-lg-4'>
                                            <div className='personaldetails text-justify mt-3'>
                                                <label htmlFor="employeeId">Employee ID</label><br />
                                                <input type="number" name="employeeId" id="employeeId" value={updatedAdmin.employeeId || ''} onChange={handleChange} placeholder='Employee ID' />
                                            </div>
                                        </div>

                                        <div className='col-md-4 col-lg-4'>
                                            <div className='personaldetails text-justify mt-3'>
                                                <label htmlFor="employeeName">Employee Name</label><br />
                                                <input type="text" name="employeeName" id="employeeName" value={updatedAdmin.employeeName || ''} onChange={handleChange} placeholder='Employee Name' />
                                            </div>
                                        </div>
                                        
                                        <div className='col-md-4 col-lg-4'>
                                            <div className='personaldetails text-justify mt-3'>
                                                <label htmlFor="branchName">Branch Name</label><br />
                                                <input type="text" name="branchName" id="branchName" value={updatedAdmin.branchName || ''} onChange={handleChange} placeholder='Branch Name' />
                                            </div>
                                        </div>

                                        <div className='col-md-4 col-lg-4'>
                                            <div className='personaldetails text-justify mt-3'>
                                                <label htmlFor="isActive">Is Active</label><br />
                                                <input type="checkbox" name="isActive" id="isActive" checked={updatedAdmin.isActive} onChange={handleChange} /> {' '}
                                                {updatedAdmin.isActive ? 'Yes' : 'No'}
                                            </div>
                                        </div>

                                        <div className='col-md-12 mt-4 mb-5'>
                                            <button className='btn btn-primary' onClick={handleUpdate}>Update Admin</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewEmployee;
